import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { SelectProps } from 'antd/lib';
import * as React from 'react';
import { Select } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import suggestService from '@/apis/suggest/service';
import { tagRender } from '@/components/bases/BaseTag';

export interface IEmrTagProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<SelectProps, 'name'> {}

const EmrTag: React.FC<IEmrTagProps> = ({ field, disabled, name, labelProps = {}, ...rest }) => {
  const { data } = suggestService.useGetTags();
  const options: DefaultOptionType[] = data?.data?.map((d: any) => ({ value: d.text, label: d.text }));
  return (
    <EmrFormItem
      field={field}
      name={name}
      initialValue={disabled ? undefined : field?.default || undefined}
      {...labelProps}
    >
      <Select
        disabled={disabled}
        tagRender={tagRender}
        mode="tags"
        options={options}
        placeholder={field?.placeholder}
        className={'base-select w-full '}
        {...rest}
      />
    </EmrFormItem>
  );
};
export default EmrTag;
